// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFoundPage_container__m9rTl","title":"NotFoundPage_title__Z51US","button":"NotFoundPage_button__N4om1"};